import { render } from "./MultiSelectField.vue?vue&type=template&id=841f4996"
import script from "./MultiSelectField.vue?vue&type=script&lang=js"
export * from "./MultiSelectField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MultiSelectField.vue"]])

export default __exports__